import { isCivilDateBefore } from './civil-date.js';
import { nextPeriodOn } from './recurrence.js';
const coversDate = (pause, date) => {
    const hasStarted = pause.pausedFrom === null || !isCivilDateBefore(date, pause.pausedFrom);
    const hasNotEnded = pause.resumeOn === null || isCivilDateBefore(date, pause.resumeOn);
    return hasStarted && hasNotEnded;
};
/**
 * The next period whose due date falls outside the pause. The window is tested against the due
 * date the series produces, never against `from`: a pause set for a later date leaves everything
 * due before it standing, and counting from `resumeOn` up front would hide those. A pause under
 * way with no resume date swallows the rest of the series, so there is no next period to name.
 */
export const nextPeriodOutsidePause = (rule, pause, from) => {
    const candidate = nextPeriodOn(rule, from);
    if (candidate === null || pause === null) {
        return candidate;
    }
    if (!coversDate(pause, candidate.dueDate)) {
        return candidate;
    }
    if (pause.resumeOn === null) {
        return null;
    }
    return nextPeriodOn(rule, pause.resumeOn);
};
//# sourceMappingURL=payment-pause.js.map